export default {
  Clear: {
    Dawn: {
      backgroundColor: "#FFD700",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Day: {
      backgroundColor: "#87CEEB",
      textColor: "#000000",
      borderColor: "#1E90FF",
    },
    Night: {
      backgroundColor: "#000080",
      textColor: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
  },
  Snow: {
    Dawn: {
      backgroundColor: "#87CEEB",
      textColor: "#000000",
      borderColor: "#000080",
    },
    Day: {
      backgroundColor: "#FFFFFF",
      textColor: "#000000",
      borderColor: "#4682B4",
    },
    Night: {
      backgroundColor: "#ADD8E6",
      textColor: "#000000",
      borderColor: "#4682B4",
    },
  },
  Rain: {
    Dawn: {
      backgroundColor: "#708090",
      textColor: "#FFFFFF",
      borderColor: "#2F4F4F",
    },
    Day: {
      backgroundColor: "#4682B4",
      textColor: "#FFFFFF",
      borderColor: "#1E90FF",
    },
    Night: {
      backgroundColor: "#2F4F4F",
      textColor: "#FFFFFF",
      borderColor: "#708090",
    },
  },
  Drizzle: {
    Dawn: {
      backgroundColor: "#B0C4DE",
      textColor: "#000000",
      borderColor: "#2F4F4F",
    },
    Day: {
      backgroundColor: "#87CEFA",
      textColor: "#000000",
      borderColor: "#4169E1",
    },
    Night: {
      backgroundColor: "#778899",
      textColor: "#FFFFFF",
      borderColor: "#B0C4DE",
    },
  },
  Clouds: {
    Dawn: {
      backgroundColor: "#778899",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
    Day: {
      backgroundColor: "#B0C4DE",
      textColor: "#000000",
      borderColor: "#B0C4DE",
    },
    Night: {
      backgroundColor: "#708090",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
  },
  Thunderstorm: {
    Dawn: {
      backgroundColor: "#191970",
      textColor: "#FFFFFF",
      borderColor: "#000080",
    },
    Day: {
      backgroundColor: "#4169E1",
      textColor: "#FFFFFF",
      borderColor: "#000080",
    },
    Night: {
      backgroundColor: "#000080",
      textColor: "#FFFFFF",
      borderColor: "#4169E1",
    },
  },
  Mist: {
    Dawn: {
      backgroundColor: "#DCDCDC",
      textColor: "#000000",
      borderColor: "#808080",
    },
    Day: {
      backgroundColor: "#D3D3D3",
      textColor: "#000000",
      borderColor: "#808080",
    },
    Night: {
      backgroundColor: "#A9A9A9",
      textColor: "#FFFFFF",
      borderColor: "#DCDCDC",
    },
  },
  Smoke: {
    Dawn: {
      backgroundColor: "#D3D3D3",
      textColor: "#000000",
      borderColor: "#808080",
    },
    Day: {
      backgroundColor: "#A9A9A9",
      textColor: "#FFFFFF",
      borderColor: "#808080",
    },
    Night: {
      backgroundColor: "#696969",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
  },
  Haze: {
    Dawn: {
      backgroundColor: "#FFDAB9",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Day: {
      backgroundColor: "#FFE4B5",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Night: {
      backgroundColor: "#FFDEAD",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
  },
  Dust: {
    Dawn: {
      backgroundColor: "#DEB887",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Day: {
      backgroundColor: "#D2B48C",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Night: {
      backgroundColor: "#8B4513",
      textColor: "#FFFFFF",
      borderColor: "#DEB887",
    },
  },
  Fog: {
    Dawn: {
      backgroundColor: "#D3D3D3",
      textColor: "#000000",
      borderColor: "#808080",
    },
    Day: {
      backgroundColor: "#A9A9A9",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
    Night: {
      backgroundColor: "#696969",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
  },
  Sand: {
    Dawn: {
      backgroundColor: "#FFE4C4",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Day: {
      backgroundColor: "#FFDAB9",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
    Night: {
      backgroundColor: "#FFDEAD",
      textColor: "#000000",
      borderColor: "#8B4513",
    },
  },
  Ash: {
    Dawn: {
      backgroundColor: "#808080",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
    Day: {
      backgroundColor: "#A9A9A9",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
    Night: {
      backgroundColor: "#696969",
      textColor: "#FFFFFF",
      borderColor: "#D3D3D3",
    },
  },
  Squall: {
    Dawn: {
      backgroundColor: "#4682B4",
      textColor: "#FFFFFF",
      borderColor: "#1E90FF",
    },
    Day: {
      backgroundColor: "#4169E1",
      textColor: "#FFFFFF",
      borderColor: "#1E90FF",
    },
    Night: {
      backgroundColor: "#000080",
      textColor: "#FFFFFF",
      borderColor: "#1E90FF",
    },
  },
  Tornado: {
    Dawn: {
      backgroundColor: "#2F4F4F",
      textColor: "#FFFFFF",
      borderColor: "#000080",
    },
    Day: {
      backgroundColor: "#1E90FF",
      textColor: "#FFFFFF",
      borderColor: "#000080",
    },
    Night: {
      backgroundColor: "#000080",
      textColor: "#FFFFFF",
      borderColor: "#1E90FF",
    },
  },
};
